import { type Job, JobTask } from "encamp-prisma/generated/browser";
import { z } from "zod";

import { INVOICE_PIPELINE_NAMES } from "./invoicePipelineRegistry";

// Shared here so job queue and waste data access can parse persisted jobs without depending on each other.
export const invoicePipelineParametersSchema = z
  .object({
    pipelineName: z.enum(INVOICE_PIPELINE_NAMES),
    tenantId: z.string().uuid(),
    sourceDocumentId: z.string().uuid(),
    sourceS3Bucket: z.string().trim().min(1),
    sourceFiles: z.object({ source: z.string().trim().min(1) }).strict(),
    year: z.number().int().min(2000).max(2200).optional(),
    pipelineId: z.string().uuid().optional(),
  })
  .strict();

export type InvoicePipelineParameters = z.infer<typeof invoicePipelineParametersSchema>;

export type InvoiceProcessingJob = {
  job: Job;
  parameters: InvoicePipelineParameters;
};

/** Parses a DATA_PIPELINE job that represents a waste invoice processing run. */
export function parseInvoiceProcessingJob(job: Job): InvoiceProcessingJob | null {
  if (job.task !== JobTask.DATA_PIPELINE || job.tenantId == null) return null;
  const parameters = invoicePipelineParametersSchema.safeParse(job.parameters);
  if (
    !parameters.success ||
    parameters.data.pipelineId == null ||
    parameters.data.tenantId !== job.tenantId ||
    parameters.data.sourceDocumentId !== job.documentId
  ) {
    return null;
  }
  return { job, parameters: parameters.data };
}
